const Step3Data = {
  subtitle: {
    pl: "Podaj orientacyjną cenę Systemu Wizyjnego dla Twojej produkcji:",
    en: "Provide an approximate price for the Vision System for your production:",
  },
  darkbar: {
    pl: "Szacowana cena Systemu Wizyjnego dla Twojej produkcji",
    en: "Estimated price of the Vision System for your production",
  },
  label: {
    pl: "Cena Systemu Wizyjnego (PLN):",
    en: "Price of the Vision System (EUR):",
  },
  tip: {
    pl: '<p>Tutaj wpisz cenę z oferty na system wizyjny dla rozważanego problemu. Jeśli potrzebujesz pomocy w dobraniu odpowiedniej wartości <a href="https://mv-center.com/skonsultuj-wdrozenie/">skontaktuj się z nami</a>.</p>',
    en: '<p>Enter the price from the quotation for the vision system for the problem you are considering here. If you need help selecting the right value <a href="https://mv-center.com/en/consult-implementation/">contact us</a>.</p>',
  },
};
export default Step3Data;
